import { FETCH_PATIENT_VISITS_START, FETCH_PATIENT_VISITS_SUCCESS,FETCH_VISIT_AUDIT_SUCCESS, FETCH_VISIT_AUDIT_ERROR, FETCH_PATIENT_VISITS_ERROR, ADD_UPDATE_VISIT_START, ADD_UPDATE_VISIT_SUCCESS, ADD_UPDATE_VISIT_ERROR, DELETE_PATIENT_EXAMINATION_SUCCESS, DELETE_PATIENT_EXAMINATION_ERROR, RESET_PATIENT_VISITS, UPLOAD_VISIT_DOCUMENT_SUCCESS, UPLOAD_VISIT_DOCUMENT_ERROR, DELETE_VISIT_DOCUMENT_SUCCESS, DELETE_VISIT_DOCUMENT_ERROR, CREATE_HL7_MESSAGE_SUCCESS, CREATE_HL7_MESSAGE_ERROR, FETCH_VISIT_INVOICES_SUCCESS, FETCH_VISIT_INVOICES_START, FETCH_VISIT_INVOICES_ERROR, CLOSE_INVOICE_MODAL, FETCH_INVOICE_RECEIPTS_SUCCESS, FETCH_INVOICE_RECEIPTS_ERROR, FETCH_APPOINTMENT_NOTES_SUCCESS, FETCH_APPOINTMENT_NOTES_ERROR } from "../../actions/receptionist/visitsAction";
import _ from "lodash";

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    visits: [],
    selectedVisitInvoices: [],
    invoiceModal: false,
    selectedInvoiceReceipts: []
};

const visitsReducer = (state = INIT_STATE, action) => {
    let newState;
    let newVisits;
    let index;
    switch (action.type) {
        case FETCH_PATIENT_VISITS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_PATIENT_VISITS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, visits: [...action.visits] };
        }
        case FETCH_PATIENT_VISITS_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }
        case ADD_UPDATE_VISIT_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case ADD_UPDATE_VISIT_SUCCESS: {
            newState = _.cloneDeep(state);

            index = state.visits.findIndex(visitItem => visitItem.visitId === action.visit.visitId);
            if (index === -1) {
                newState.visits.push(action.visit);
            } else {
                newState.visits[index] = _.cloneDeep(action.visit);;
            }
            return { ...newState, loading: false };
        }

        case ADD_UPDATE_VISIT_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }

        case DELETE_PATIENT_EXAMINATION_SUCCESS: {
            newState = _.cloneDeep(state);
            index = newState.visits.findIndex(visitItem => visitItem.visitId === action.visitData.visitId);


            if (index === -1) {
                return newState;
            } else {

                let selectetedVisit = newState.visits[index];
                let selectedExaminations = [...selectetedVisit.examinations];
                let modifiedExaminations = selectedExaminations.filter(examination => examination.examinationId !== action.visitData.examinationId)
                selectetedVisit.examinations = [...modifiedExaminations];
                newState.visits[index] = _.cloneDeep(selectetedVisit);


                return newState;
            }

        }
        case DELETE_PATIENT_EXAMINATION_ERROR: {
            return { ...state, error: '', message: '', loading: false };

        }

        case RESET_PATIENT_VISITS: {
            newState = _.cloneDeep(state);
            newState.visits = [];
            return { ...newState, error: '', message: '', loading: false };
        }
        case UPLOAD_VISIT_DOCUMENT_SUCCESS: {
            newState = _.cloneDeep(state);

            index = newState.visits.findIndex(visitItem => visitItem.visitId === action.visit.visitNo);
            if (index === -1) {
                return newState;
            } else {
                let selectedVisit = newState.visits[index];
                selectedVisit.documents.push(_.cloneDeep(action.visit));
                newState.visits[index] = _.cloneDeep(selectedVisit);
                return newState;
            }
        }
        case UPLOAD_VISIT_DOCUMENT_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }
        case DELETE_VISIT_DOCUMENT_SUCCESS: {
            newState = _.cloneDeep(state);
            index = newState.visits.findIndex(visitItem => visitItem.visitId === action.visitRequest.visitNo);

            if (index === -1) {
                return newState;
            } else {
                let selectedVisit = newState.visits[index];
                let documents = selectedVisit.documents.filter(documentItem => documentItem.documentId !== action.visitRequest.documentId && documentItem.visitNo !== action.visitRequest.visitNo);
                selectedVisit.documents = _.cloneDeep(documents);
                newState.visits[index] = _.cloneDeep(selectedVisit);
                return newState;
            }
        }
        case DELETE_VISIT_DOCUMENT_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }
        case CREATE_HL7_MESSAGE_SUCCESS: {
            newState = _.cloneDeep(state);
            index = newState.visits.findIndex(visitItem => visitItem.visitId === action.visit.visit.visitId);

            if (index === -1) {
                return newState;
            } else {
                let selectedVisit = newState.visits[index];
                selectedVisit.HL7Message = action.visit.hl7Message;
                newState.visits[index] = _.cloneDeep(selectedVisit);
                return newState;
            }
        }
        case CREATE_HL7_MESSAGE_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }

        case FETCH_VISIT_INVOICES_ERROR:
        case CLOSE_INVOICE_MODAL: {
            return { ...state, error: '', message: '', invoiceModal: false, selectedVisitInvoices: [] };
        }

        case FETCH_VISIT_INVOICES_SUCCESS: {
            newState = _.cloneDeep(state);
            if (action.invoices.length > 0) {
                newState.selectedVisitInvoices = [...action.invoices];
                return { ...newState, invoiceModal: true }
            } else {
                return { ...state, invoiceModal: false }
            }
        }

        case FETCH_VISIT_AUDIT_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.auditInfo = action.auditInfo;
            return { ...newState, loading: false };
        }

        case FETCH_APPOINTMENT_NOTES_SUCCESS: {
            newState = _.cloneDeep(state);

            const { appointmentId, appointmentNotes } = action.payload;
            newState.appointmentNotes = {
                ...newState.appointmentNotes, // preserve existing appointmentNotes
                [appointmentId]: appointmentNotes // dynamically set by appointmentId
            };

            return { ...newState, loading: false };
        }

        case FETCH_APPOINTMENT_NOTES_ERROR: {
            return { ...state,appointmentNotes:[], loading: false };
        }

        case FETCH_INVOICE_RECEIPTS_SUCCESS: {
            return { ...state, selectedInvoiceReceipts: action.receipts.length > 0 ? [...action.receipts] : [] }
        }
        case FETCH_INVOICE_RECEIPTS_ERROR: {
            return { ...state, selectedInvoiceReceipts: [] }
        }

        default:
            return state;
    }
}

export default visitsReducer;